import { render, staticRenderFns } from "./feedback-dialog.vue?vue&type=template&id=497f1cc1&"
import script from "./feedback-dialog.vue?vue&type=script&lang=js&"
export * from "./feedback-dialog.vue?vue&type=script&lang=js&"
import style0 from "./feedback-dialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports